import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PopoverAssignmentsPage } from './popover-assignments.page';

const routes: Routes = [
  {
    path: '',
    component: PopoverAssignmentsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PopoverAssignmentsPageRoutingModule {}
